// extracted by mini-css-extract-plugin
export default {"container":"Register_container__haW6T","member":"Register_member__PADL1","background":"Register_background__2H7iE"};